import {
  TaoTeDetail,
  TaoTeForm,
  TaoTeEdit,
  getTaoTeSchemaProp,
  tjbBatchUpdateCategory
} from '@/api/prod/center'

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
  if (r.skuList && r.skuList.length > 0) {
    r.skuList = r.skuList.map(item => {
      return isRequest ? {
        ...item,
        skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : [])
      } : {
        ...item,
        skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : []
      }
    })
  }

  return isRequest ? {
    ...r,
    props: JSON.stringify(r.props ? r.props : []),
    images: JSON.stringify(r.images ? r.images : []),
    specifications: JSON.stringify(r.specifications ? r.specifications : []),
    categoryIds: r.categoryIds ? r.categoryIds.join(',') : '',
    sizeGroup: JSON.stringify(r.sizeGroup ? r.sizeGroup : {}),
  } : {
    ...r,
    props: r.props ? JSON.parse(r.props) : [],
    images: r.images ? JSON.parse(r.images) : [],
    specifications: r.specifications ? JSON.parse(r.specifications) : [],
    categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
    sizeGroup: r.sizeGroup ? JSON.parse(r.sizeGroup) : {},
    templateConfig: r.templateConfig ? JSON.parse(r.templateConfig) : []
  }
}

/**
 * 获取淘宝商品详情
 * @param {*} params baseitemID
 * @returns 
 */
export const getTaoTeDetail = (params) => {
    return TaoTeDetail(params).then(res => {
        if (res.result === 1 && res.data) {
            return _formatGoodsItem(res.data)
        }
        return []
    })
}

/**
 * 获取动态表单
 * @param {*} params 
 * @returns 
 */
 export function getForm(params) {
  return TaoTeForm(params).then(res => {
      if (res.result === 1) {
          if (res.data.saleProp?.children?.length > 2) {
            window._globel_vm.$message.error('当前类目为三/四规格类目，暂不支持铺货')
            return false
          }
          if (!res.data.saleProp?.children?.length) {
            window._globel_vm.$message.error('当前类目为无规格类目，暂不支持铺货')
            return false
          }
          return res.data
      } else {
        return false
      }
      return {}
  }).catch(err => {
    return false
  })
}

/**
 * 【淘宝】商品级联属性信息获取
 * @param {*} params 
 * @returns 
 */
 export function getItemPublishSchemaProp(params) {
  return getTaoTeSchemaProp(params).then(res => {
      if (res.result === 1) {
          return res.data
      }
      return {}
  })
}

/**
 * 编辑保存
 * @param {*} params 
 * @returns 
 */
 export function editTjbDetail(params) {
  return TaoTeEdit(_formatGoodsItem(params, true)).then(res => {
      if (res.result === 1) {
          return true
      } else {
          return false
      }
  })
}

// 批量修改类目
export function batchTjbCategory(data) {
  return tjbBatchUpdateCategory(data).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}

